import { Component, OnInit, NgZone } from '@angular/core';
import { CartService } from 'src/app/services/cart/cart.service';
import { StoreMetaInfo, FoodCartItem, FoodCart } from 'src/app/models/cart-models';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html.pipe';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { ModalController, AlertController, NavController } from '@ionic/angular';
import { BottomModalComponent } from 'src/app/modals/bottom-modal/bottom-modal.component';
import { I18ConfigService } from 'src/app/services/shared/I18-config.service';
import { SeoService } from 'src/app/services/seo.service';
import { CustomizationComponent } from '../menu/customization/customization.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.page.html',
  styleUrls: ['./cart.page.scss'],
})
export class CartPage implements OnInit {

  veg = '../../../../../assets/icon/veg.svg';
  nonVeg = '../../../../../assets/icon/nonveg.svg';
  cartItems: FoodCartItem[];
  storeInfo: StoreMetaInfo;
  cart: FoodCart;
  totalQuantity: number;
  totalPrice: number;
  storeCharges: number;
  currencyCode: string;
  showLoader: number;
  removeTitle: string;
  removeText: string;
  clearTitle: string;
  clearText: string;
  noBtn: string;
  yesBtn: string;
  // tslint:disable-next-line: max-line-length
  constructor(private seoService: SeoService, private cartService: CartService, private safeHtml: SafeHtmlPipe, private loaderService: LoaderService, private modalController: ModalController, private alertController: AlertController, private navControl: NavController, private i18ConfigService: I18ConfigService, private translate: TranslateService) {
    this.initCartState();
    this.currencyCode = i18ConfigService.getCurrency();
    this.seoService.updatePageTitle('cart|food');
  }


  initCartState() {
    this.storeInfo = {} as StoreMetaInfo;
    this.cartItems = [] as FoodCartItem[];
    this.cart = {} as FoodCart;
    this.storeCharges = 10;
    this.showLoader = 1;
  }

  ngOnInit() {
    // console.log('nginit');
  }
  ionViewWillEnter() {
    this.initCartState();
    this.renderCartData();
    this.cartService.foodCartSubject.subscribe((newCartData) => {
      this.cart = newCartData;
      this.cartItems = [...newCartData.list];
      this.updateCartParams();
    });

  }

  updateCartParams() {
    this.totalQuantity = 0;
    this.totalPrice = 0;
    this.cartItems.forEach((element, index) => {
      this.totalQuantity += element.quantity;
      let itemTotalPrice = ((element.price || 0 - 0) + (element.additionalPrice || 0 - 0) || 0) * element.quantity; // -0 is added to convert string value (assigned to interger variable) to number
      this.totalPrice += itemTotalPrice;
      // this.cartItems[index].totalPrice = itemTotalPrice;
    });
    if (this.cartItems.length <= 0) {
      this.showLoader = 0;
    }
  }
  renderCartData() {
    this.cartService.getCartList('food').subscribe(response => {
      this.storeInfo = response.storeMetaInfo || {} as StoreMetaInfo;
      this.cartItems = response.cartlist || [] as FoodCartItem[];
      this.updateCartParams();
      this.cart.storeId = this.storeInfo.id;
      this.cart.locationId = response.location_id;
      this.cart.list = [...this.cartItems];
    });
  }


  public async addItemToCart(menuItem, optionList?, additionalPrice = 0, updateCartId: number = null) {
    await this.loaderService.presentLoading('Updating Cart');
    // translation from componennt
    // tslint:disable-next-line: prefer-const
    let cartItem: FoodCartItem = { ...menuItem } as FoodCartItem;
    cartItem.optionList = optionList || [];
    cartItem.quantity = 1;
    await this.cartService.addMenuItem(cartItem, menuItem.storeId, menuItem.locationId, 0, updateCartId);
    this.initCartState();
    await this.renderCartData();
    await this.loaderService.loading.dismiss();
  }


  public async removeItemFromCart(menuItem) {
    await this.loaderService.presentLoading('Updating Cart');
    await this.cartService.removeCartItemById(menuItem);
    this.initCartState();
    await this.renderCartData();
    await this.loaderService.loading.dismiss();
  }

  async customizeItem(menuItem, isNew: boolean = false) {
    const modal = await this.modalController.create({
      component: CustomizationComponent,
      componentProps: {
        menuItem,
      },
      backdropDismiss: true
    });
    modal.onDidDismiss().then((response) => {
      if (response.data && response.data.selectedMenuOptions && response.data.selectedMenuOptions.length > 0) {
        if (isNew) {
          this.addItemToCart(menuItem, response.data.selectedMenuOptions, response.data.additionalPrice || 0);
        } else {
          this.addItemToCart(menuItem, response.data.selectedMenuOptions, response.data.additionalPrice || 0, menuItem.cartId);
        }
      }
    });
    return await modal.present();
  }



  async presentGoToCartAlert() {
    this.translate.get('CART.order_placing', {value: 'world'}).subscribe((res: string) => {
      this.removeTitle = res;
    });
    this.translate.get('CART.order_placing', {value: 'world'}).subscribe((res: string) => {
      this.removeText = res;
    });
    this.translate.get('CART.order_placing', {value: 'world'}).subscribe((res: string) => {
      this.noBtn = res;
    });
    this.translate.get('CART.order_placing', {value: 'world'}).subscribe((res: string) => {
      this.yesBtn = res;
    });
    const alert = await this.alertController.create({
      header: this.removeTitle,
      message: this.removeText,
      buttons: [
        {
          text: this.noBtn,
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }, {
          text: this.yesBtn,
          handler: () => {
            this.navControl.navigateForward(['shopping/food/cart']);
            // this.ngZone.run(() => this.router.navigate(['shopping/food/cart']));
          }
        }
      ]
    });

    await alert.present();
  }


  async presentRepeatItemModal(menuItem) {
    const modal = await this.modalController.create({
      component: BottomModalComponent,
      cssClass: 'tx-bottom-modal',
      componentProps: {
        menuItem,
        currencyCode: this.currencyCode
      },
      backdropDismiss: true
    });
    modal.onDidDismiss().then((response) => {
      if (response.data && response.data.methodType) {
        if (response.data.methodType === 'customize') {
          this.customizeItem(menuItem, true);
        } else {
          const optionListStr = menuItem.optionList ? JSON.stringify(menuItem.optionList.sort()) : '[]';
          let dataFromCart: FoodCartItem;
          let foodCart = { ...this.cart };
          foodCart.list.reverse().forEach((currentItem, index) => {
            if (currentItem.optionList === null) {
              currentItem.optionList = [];
            }
            // tslint:disable-next-line: max-line-length
            if (typeof dataFromCart === 'undefined' && menuItem.id === currentItem.id && optionListStr === JSON.stringify(currentItem.optionList.sort())) {
              dataFromCart = currentItem;
            }
          });
          if (dataFromCart && dataFromCart.id) {
            this.addItemToCart(menuItem, dataFromCart.optionList, dataFromCart.price - menuItem.price || 0);
          }
        }
      }

    });
    return await modal.present();
  }


  public async clearCart() {
    this.translate.get('CART.confirm_msg', {value: 'world'}).subscribe((res: string) => {
      this.clearTitle = res;
    });
    this.translate.get('CART.confirm_text', {value: 'world'}).subscribe((res: string) => {
      this.clearText = res;
    });
    this.translate.get('CART.no', {value: 'world'}).subscribe((res: string) => {
      this.noBtn = res;
    });
    this.translate.get('CART.yes', {value: 'world'}).subscribe((res: string) => {
      this.yesBtn = res;
    });
    const alert = await this.alertController.create({
      header: this.clearTitle,
      message: this.clearText,
      buttons: [
        {
          text: this.noBtn,
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }, {
          text: this.yesBtn,
          handler: async () => {
            await this.loaderService.presentLoading('Updating Cart');
            await this.cartService.clearCart();
            // if failed handle error case
            await this.renderCartData();
            await this.loaderService.loading.dismiss();
            // this.ngZone.run(() => this.router.navigate(['shopping/food/cart']));
          }
        }
      ]
    });

    await alert.present();
  }
}
